<template>
  <v-container class="fill-height d-flex justify-center align-center mt-8">
    <v-card class="pa-6" width="600" v-if="status === ''">
      <v-progress-circular indeterminate color="primary" size="64" />
    </v-card>

    <v-card class="pa-6 text-center" width="600" v-else>
      <v-icon size="48" :color="status === 'confirmed' ? 'success' : 'error'">
        {{ status === 'confirmed' ? 'mdi-check-circle' : 'mdi-cancel' }}
      </v-icon>
      <h2 class="mt-4">{{ statusMessage }}</h2>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'pinia'
import { useExecutionStore } from '@/store/index'

export default {
  name: 'QuoteApproval',
  data () {
    return {
      status: '' // '', 'confirmed', 'cancelled'
    }
  },
  computed: {
    statusMessage () {
      if (this.status === 'confirmed') return 'Quote confirmed successfully.'
      if (this.status === 'cancelled') return 'Quote was cancelled.'
      return 'Processing...'
    }
  },
  mounted () {
    const { action, payload } = this.$route.query

    if (!payload || !['confirm', 'cancel'].includes(action)) {
      this.status = 'cancelled'
      return
    }

    const decoded = atob(decodeURIComponent(payload) || '')
    const parsed = JSON.parse(decoded || '{}')

    if (!parsed?.rfq_id || !parsed?.rfq_order_quote_id || !parsed?.rfq_order_px) {
      this.status = 'cancelled'
      return
    }

    if (action === 'confirm') {
      this.makeQuoteOrder(parsed)
        .then(() => {
          this.status = 'confirmed'
        })
        .catch(() => {
          this.status = 'cancelled'
        })
    } else {
      this.status = 'cancelled'
    }
  },
  methods: {
    ...mapActions(useExecutionStore, [
      'makeQuoteOrder',
      'cancelQuote'
    ]),
  }
}
</script>